var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12015e-05 0.995605C7.12015e-05 0.443321 0.447786 -0.00439453 1.00007 -0.00439453H4.00007V0.995605H1.00007V3.99561H7.12015e-05V0.995605ZM15.0001 0.995605H12.0001V-0.00439453H15.0001C15.5524 -0.00439453 16.0001 0.443321 16.0001 0.995605V3.99561H15.0001V0.995605ZM1.00007 14.9956V11.9956H0L5.34014e-05 14.9956C6.32322e-05 15.5479 0.447776 15.9956 1.00005 15.9956H4.00007V14.9956H1.00007ZM15.0001 14.9956V11.9956H16.0001V14.9956C16.0001 15.5479 15.5524 15.9956 15.0001 15.9956H12.0001V14.9956H15.0001Z",
    fill: "#444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19055 10.2813H5.71436V11.8051H4.19055V10.2813Z",
    fill: "#444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66674 11.8051H4.19055V13.3289H2.66674V11.8051Z",
    fill: "#444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66674 8.75751H4.19055V10.2813H2.66674V8.75751Z",
    fill: "#444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 11.8051H7.23817V13.3289H5.71436V11.8051Z",
    fill: "#444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 8.75751H7.23817V10.2813H5.71436V8.75751Z",
    fill: "#444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47626 3.42418H3.42864V6.4718H6.47626V3.42418ZM12.5715 3.42418H9.52388V6.4718H12.5715V3.42418ZM12.5715 9.51941H9.52388V12.567H12.5715V9.51941ZM7.23817 2.66227V7.2337H2.66674V2.66227H7.23817ZM13.3334 2.66227V7.2337H8.76198V2.66227H13.3334ZM8.76198 8.75751V13.3289H13.3334V8.75751H8.76198Z",
    fill: "#444"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19055 4.18608H5.71436V5.70989H4.19055V4.18608Z",
    fill: "#444"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2858 4.18608H11.8096V5.70989H10.2858V4.18608Z",
    fill: "#444"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2858 10.2813H11.8096V11.8051H10.2858V10.2813Z",
    fill: "#444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrscan);
export default __webpack_public_path__ + "static/media/qrscan.eaf5f9952d31ed3230857b88511d3f74.svg";
export { ForwardRef as ReactComponent };